// Relative time for the news feed, computed in the browser.
//
// The API also ships a `time` string, but it is stamped when the server builds
// the response — on a page left open it froze at "12 นาที" while the story kept
// ageing, and it was Thai even in English mode. Anything with a `datetime`
// (epoch seconds) gets its label recomputed here on every render instead, which
// is what makes a pushed feed read as genuinely live.

const MIN = 60, HOUR = 3600, DAY = 86400;

/**
 * Age of an epoch-seconds timestamp as a finished phrase.
 * Returns '' when there is no usable timestamp, so callers can fall back to the
 * server's string: `ago(n.datetime, en) || n.time`.
 */
export function ago(datetimeSec: number | undefined | null, en = false): string {
  if (!datetimeSec || !Number.isFinite(datetimeSec)) return '';
  // Tolerate milliseconds — a provider handing back ms would otherwise read as
  // a headline filed in the year 57000.
  const sec = datetimeSec > 1e11 ? datetimeSec / 1000 : datetimeSec;
  const diff = Math.max(0, Date.now() / 1000 - sec);
  if (diff < MIN) return en ? 'just now' : 'เมื่อสักครู่';
  if (diff < HOUR) {
    const m = Math.floor(diff / MIN);
    return en ? `${m} min ago` : `${m} นาทีที่แล้ว`;
  }
  if (diff < DAY) {
    const h = Math.floor(diff / HOUR);
    return en ? `${h} hr ago` : `${h} ชม.ที่แล้ว`;
  }
  const d = Math.floor(diff / DAY);
  return en ? `${d} day${d > 1 ? 's' : ''} ago` : `${d} วันที่แล้ว`;
}

/** Wall clock for "last updated" stamps: 14:07:32 in the reader's own zone. */
export function clockTime(ms: number): string {
  if (!ms) return '--:--:--';
  return new Date(ms).toLocaleTimeString([], { hour12: false });
}
